import axios from "axios";
import baseUrl from "@/api";

// =============================
// 📦 CACHE EN MEMORIA
// =============================
const cache = {};

// =============================
// 🔢 CONFIG UI
// =============================
const UI_PAGE_SIZE = 24;

export function useCategoryCache() {

  // =====================================
  // 📦 CARGAR CATEGORÍA (PRIMERA PÁGINA)
  // =====================================
  async function loadCategory(
    handle,
    { location_id = null } = {}
  ) {
    const key = `cat-${handle}-${location_id || "all"}`;

    // 👉 devolver cache si existe
    if (cache[key]) {
      return cache[key];
    }

    const res = await axios.get(
      `${baseUrl}/shopify/category/${handle}`,
      {
        params: {
          limit: UI_PAGE_SIZE,
          location_id
        }
      }
    );

    cache[key] = {
      key,
      handle,
      location_id,
      limit: UI_PAGE_SIZE,
      pages: [
        {
          productos: res.data.productos || [],
          nextCursor: res.data.nextCursor || null,
          hasMore: res.data.hasMore
        }
      ]
    };

    return cache[key];
  }

  // =====================================
  // ➕ CARGAR SIGUIENTE PÁGINA (CURSOR)
  // =====================================
 async function loadMore(handle) {
  const current = Object.values(cache).find(
    c => c.handle === handle
  );

  if (!current) return null;

  const lastPage = current.pages[current.pages.length - 1];

  if (!lastPage.hasMore || !lastPage.nextCursor) {
    return current;
  }

  const res = await axios.get(
    `${baseUrl}/shopify/category/${handle}`,
    {
      params: {
        limit: current.limit,
        cursor: lastPage.nextCursor,
        location_id: current.location_id
      }
    }
  );

  current.pages.push({
    productos: res.data.productos || [],
    nextCursor: res.data.nextCursor || null,
    hasMore: res.data.hasMore
  });

  return current;
}


  // =====================================
  // 🧹 LIMPIAR CACHE (CAMBIO DE SUCURSAL)
  // =====================================
  function clearCache() {
    Object.keys(cache).forEach(k => delete cache[k]);
  }

  return {
    loadCategory,
    loadMore,
    clearCache
  };
}
